export const contentful = {
  ID: 'id',
  CONTENT_TYPE: 'contentType',
};
